import React, { FC, ReactNode } from 'react'
import block from 'bem-cn'

import './BonusInfoCell.scss'

interface IBonusInfoCellProps {
  name: string
  value: ReactNode
  className?: string
}

const b = block('bonus-info-cell')

export const BonusInfoCell: FC<IBonusInfoCellProps> = ({ name, value, className }) => (
  <div className={b.mix(className)}>
    <div className={b('value')}>{value}</div>
    <div className={b('name')}>{name}</div>
  </div>
)
